import React, { useEffect } from "react";
import { Page } from "..";
import { Botao, Box, Col, Row } from "@intechprev/componentes-web";
import { Upload } from "./Upload";
import { AdesaoService } from "./../../services";

export const Adesao: React.FC = ({ ...props }) => {
  const page = React.createRef<Page>();

  useEffect(() => {
    page.current.loading(false);
  }, []);

  async function handleDownload() {
    const pdf = await AdesaoService.Download();
    const nomeArquivo = "Formulario de Adesao.pdf";

    if (navigator.msSaveBlob) {
      // IE10+ : (has Blob, but not a[download] or URL)
      return navigator.msSaveBlob(new Blob([pdf]));
    } else {
      const url = window.URL.createObjectURL(new Blob([pdf]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeArquivo);
      document.body.appendChild(link);

      link.click();
      URL.revokeObjectURL(url);
    }
  }

  async function handleFinish(oid: number) { }

  return (
    <Page {...props} ref={page}>
      <Box>
        <h4 className="mb-4">Veja como é simples se inscrever no Codeprev</h4>
        <p>1. Após a efetivação de sua contratação pela CODEVASF</p>
        <p>a. Faça o download do Formulário de Adesão no botão abaixo;</p>
        <p>b. Preencha o Formulário de Adesão com suas informações e salve-o no seu computador;</p>
        <p>c. Realize nessa página o upload do Formulário de Adesão preenchido;</p>
        <p>d. Em breve você receberá um e-mail, onde:</p>
        <p>i. Será autorizado a efetuar a assinatura eletrônica do Formulário</p>
        <p>ii. Poderá fazer o upload dos documentos exigidos (RG, CPF)</p>
        <p>2. A documentação enviada será analisada pela Fundação São Francisco</p>
        <p>a. Se houver pendências:</p>
        <p>i. Será devolvida por e-mail apontando os ajustes necessários</p>
        <p>ii. Você deverá providenciar os ajustes e realizar novamente os procedimentos acima</p>
        <p>b. Se estiver em conformidade:</p>
        <p>i. A inscrição será homologada pela Fundação São Francisco</p>

        <Botao titulo="Baixar Formulário de Adesão" icone="fa-download" onClick={handleDownload} />
        <br />
        <br />
        <hr />
        <h4 className="mb-4">Enviar Formulário de Adesão</h4>
        <Upload onFinish={handleFinish} />
      </Box>
    </Page>
  );
};
